import { ConsentsClient } from '../clients';
import type { IAcceptOfficeConsentContentParameters } from '../types/OfficeConsentContent.parameters';

export const acceptOfficeConsentContent = async (
  params: IAcceptOfficeConsentContentParameters,
): Promise<void> => {
  await ConsentsClient.acceptOfficeConsentContent(params);
};
